import { FileWarning } from "lucide-react";
import { Alert } from "@/components/ui/alert";
import { documentacionAcreditativaRequeridaEn, type MeResponse } from "@/lib/auth";

/** MENSAJE_DOCUMENTACION_REQUERIDA es el aviso al trabajador bloqueado por la causa (#435, D9). */
export const MENSAJE_DOCUMENTACION_REQUERIDA =
  "No puedes registrar LOTOs: falta tu documentación acreditativa. Contacta con el administrador de la obra.";

/**
 * AvisoDocumentacionAcreditativa explica al CUALIFICADO o AUTORIZADO sin documentación
 * acreditativa por qué no ve los botones de operar (#435, R12), en vez de dejarle unos botones
 * que desaparecen sin explicación. Se pinta SOLO si `/me` marca la obra con
 * `documentacion_acreditativa_requerida`; los botones siguen gobernados por `puede_registrar`.
 * Es UX: el gate real es RequireLotoEditor en el servidor.
 */
export function AvisoDocumentacionAcreditativa({
  me,
  obraId,
}: {
  me: MeResponse | undefined;
  obraId: number;
}) {
  if (!me || !documentacionAcreditativaRequeridaEn(me, obraId)) {
    return null;
  }
  return (
    <Alert variant="destructive">
      <FileWarning className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
      <span>{MENSAJE_DOCUMENTACION_REQUERIDA}</span>
    </Alert>
  );
}
